import { TPublicAccount } from 'shopify-payments-types'

import { useAuth } from '../components/AuthContext'

export function useAccount<T extends TPublicAccount = TPublicAccount>() {
  return useAuth()!.account as T
}
